import React from 'react';
import ReactQueryParams from "react-query-params";
import {Col, Button, Row, Card, CardBody,Badge,ButtonToolbar} from 'reactstrap';

import * as TextManager from "../../../modules/languages/TextManager";
import * as environment from "../../../modules/environment";
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import * as http from '../../../modules/http';
import Alert from '../../../components/Alert';
import CheckBox from "../../../components/CheckBox";
import Modal from './Modal'

import {fetchOrdersDataForce} from "../../../redux/actions/OrdersActions";
import {orders_update_field,orders_update} from '../../../redux/actions/OrdersActions'

class OrderManage extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            warning: '',
            error: false,
            saved: false,
            success: false,
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchSalesDataIfNeeded());
    }

    simNumChanged = (index, value) => {
        let tmp = this.props.orderInEdit.orders.slice();

        tmp[index].simNums = value;
        this.props.dispatch(orders_update_field('orders', tmp));
    };

    saveOrders = () => {

        /*if(this.state.order === '') {
            this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectProvider});
            return;
        }*/

        this.setState({saving: true, error: false, warning: ''});

        const storeData = {
            id: this.props.orderInEdit.id,
            storeId: this.props.orderInEdit.storeId,
            storeName: this.props.orderInEdit.storeName,
            day: this.props.orderInEdit.day,
            updateDay: this.props.orderInEdit.updateDay,
            orders: this.props.orderInEdit.orders
        };

        http.postToServer(
            'order/update',
            storeData,
            (response) => {
                this.setState({saving: false, error: false});

                this.props.dispatch(orders_update(response.data));

                this.props.dispatch(fetchOrdersDataForce(this.queryParams));

                this.props.onClose();
            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})
            }
        );
    };

    render() {

        let totalSim = "";

        if(this.props.stat !== undefined) {

            //console.log(this.props.orderInEdit)
            //console.log(this.props.stat)

            let currStat = this.props.stat.find(e => e.storeId === this.props.orderInEdit.storeId);

            if(currStat !== undefined) {
                let tmp = 0;
                for (let i = 0; i < currStat.data.totalData.length; i++) {
                    tmp += parseInt(currStat.data.totalData[i].simNums);
                }

                totalSim = "סהכ סימים: " + tmp;
            }
        }

        return(

            <div className="catalog-items__wrap">
                {this.state.warning !== '' &&
                <Row >
                    <Alert color='warning' className='alert--bordered' icon >
                        <p><span style={{float: 'right'}}
                            className='bold-text'>{this.state.warning}</span>
                        </p>
                    </Alert>
                </Row>}
                {this.state.error &&
                    <Row>
                        <Alert color='danger' className='alert--bordered' icon>
                            <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                            <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                        </Alert>
                    </Row>
                }
                {this.state.success &&
                <Modal color='success' title={TextManager.getCurrentTextResource().Text.wellDone} noCancel
                       message={TextManager.getCurrentTextResource().Text.dealSucceeded}
                       approve={() => this.setState({saved: true})}/>
                }
                <div className="catalog-items" style={{paddingRight: '50px'}}>
                    {this.props.orderInEdit.orders.map((order, i) => {
                        let item = this.props.data.find(e => e.id === order.provider);
                        let currStat = this.props.stat.find(e => e.storeId === this.props.orderInEdit.storeId);

                        let curr = "";
                        if(currStat === undefined) {
                            curr = 'במלאי ריק';
                        }
                        else {
                            let currStatProviderSims = currStat.data.totalData.find(e => e.provider === order.provider);
                            curr = 'במלאי ' + (currStatProviderSims !== undefined ? currStatProviderSims.simNums : 'ריק');
                        }

                        return (
                            <div className="catalog-item" key={i} style={{padding: '10px 10px', height: '200px'}}>
                                <div className="catalog-item__img-wrap">
                                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                         src={environment.getServerBasePath() + '/providers/download?providerID=' + item.id} alt="catalog-item-img" />
                                </div>
                                <div className="catalog-item__info">
                                    <h5 className="catalog-item__title">{item.name}</h5>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    <span className="form__form-group-label">
                                        {TextManager.getCurrentTextResource().Text.simCount}
                                    </span>
                                    <input
                                        value={order.simNums}
                                        dir={"auto"}
                                        style={{backgroundColor: '#f0f8f0', width: '70px'}}
                                        name="simNumber"
                                        type="text"
                                        onChange={(event) =>
                                            this.simNumChanged(i, event.target.value)}
                                    />
                                    {this.props.orderInEdit.updateDay === "" && <span className="form__form-group-label">
                                        {curr}
                                    </span>}
                                </div>
                            </div>
                        )})
                    }
                </div>

                <Row style={{marginTop: '20px', paddingRight: '20px'}}>
                    <Col md={2}>
                        <Card>
                            <CardBody style={{padding: '10px 10px'}}>
                                <div>
                                    {totalSim}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <ButtonToolbar className="form__button-toolbar" style={{flexDirection: 'row-reverse'}}>
                    <Button color='primary' onClick={() => this.saveOrders()}>
                        {TextManager.getCurrentTextResource().Text.save}
                    </Button>
                    <Button type="button" onClick={this.props.onClose} style={{marginRight: '20px'}}>
                        {TextManager.getCurrentTextResource().Text.cancel}
                    </Button>
                </ButtonToolbar>
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        orderInEdit:state.orders.orderInEdit,
        stat: state.orders.data.stat,
        data: state.sales.data,
        status: state.sales.status,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(OrderManage))